export default __webpack_public_path__ + "static/chiller_w.38369c9b299ccf0452d3120de09ed07b.png";